import {Component, OnInit, Renderer2, Inject} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {CroquisService} from 'app/services/croquis.service';
import {Croquis} from 'app/models/croquis.model';
import {ActivatedRoute, Router} from '@angular/router';
import {EtageService} from 'app/services/etage.service';
import {Etage} from 'app/models/etage.model';
import {FormControl, FormGroup} from '@angular/forms';
import {NiveauService} from 'app/services/niveau.service';
import {Niveau} from 'app/models/niveau.model';
import {FuseConfirmationService} from '@fuse/services/confirmation';

declare function get_json(): any;

declare function get_svg(): any;

declare function js_refresh_after_load(croquis): any;

declare let myFloorplan: any;

@Component({
    selector: 'app-croquis',
    templateUrl: './croquis.component.html',
    styleUrls: ['./croquis.component.scss', './floorplanner.css', './goeditor.css']
})
export class CroquisComponent implements OnInit {
    // Paramètres URL
    dossier_intervention_id: number;
    fiche_intervention_id: number;
    etage_id: number;

    formSelectEtage: FormGroup;
    currentCroquis: Croquis = new Croquis();
    etages: Etage[] = [];
    niveaux: Niveau[] = [];

    jsonOnLoad: string;

    constructor(
        private renderer2: Renderer2,
        @Inject(DOCUMENT) private document: Document,
        private croquisService: CroquisService,
        private route: ActivatedRoute,
        private etageService: EtageService,
        private niveauService: NiveauService,
        private fuseConfirmationService: FuseConfirmationService,
        public router: Router,
        public window: Window
    ) {
    }

    ngOnInit(): void {
        this.loadScript('assets/floorplannerJS/initFloorplan.js');

        this.route.params.subscribe((params) => {
            this.dossier_intervention_id = params['idDossierIntervention'];
            this.fiche_intervention_id = params['idFicheIntervention'];
            this.etage_id = params['idEtage'];

            this.getEtages();
            this.getNiveaux();
            this.initForm();
            this.load_projet();
        });
    }

    loadScript(src: string) {
        const script = this.renderer2.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        this.renderer2.appendChild(this.document.body, script);
    }

    nouveau_projet() {
        this.currentCroquis = new Croquis();
        this.currentCroquis.etage_id = this.etage_id;
        this.currentCroquis.nom = 'Temp';
    }

    initForm() {
        this.formSelectEtage = new FormGroup({
            champ_etage: new FormControl(+this.etage_id)
        });
    }

    save_projet() {
        let croquis = new Croquis();
        if (this.currentCroquis) {
            croquis = this.currentCroquis;
        }

        this.jsonOnLoad = get_json();
        croquis.data = get_json();
        const serializer = new XMLSerializer();
        croquis.path = serializer.serializeToString(get_svg());
        croquis.hauteur_plafond = +(document.querySelector('#hauteurPlafondInput') as HTMLInputElement).value;

        this.croquisService.store(croquis).subscribe((c) => {
            this.currentCroquis = c;
        });
    }

    load_projet() {
        this.croquisService.getCroquis(this.etage_id).subscribe((croquis) => {
            if (croquis == null) {
                this.nouveau_projet();
            } else {
                this.currentCroquis = croquis;
            }
            try {
                js_refresh_after_load(this.currentCroquis);

                this.jsonOnLoad = get_json();

            } catch (e) {

            }


            setTimeout(() => {
                const inputGrosseurGrille = <HTMLInputElement>(this.document.getElementById('gridSizeInput'));
                inputGrosseurGrille.value = '0.1';
                // @ts-ignore
                window.myFloorplan.changeGridSize(inputGrosseurGrille);
            }, 500);

        });
    }

    changement_etage_verification(etage_id) {
        if (this.jsonOnLoad != get_json()) {
            const confirmation = this.fuseConfirmationService.open({
                title: 'Sauvegarde',
                message: 'Voulez-vous sauvegarder ce plan avant de changer?',
                actions: {
                    confirm: {
                        label: 'Sauvegarde'
                    },
                    cancel: {
                        label: 'Non'
                    }
                }
            });

            confirmation.afterClosed().subscribe((result) => {
                if (result === 'confirmed') {
                    this.save_projet();
                }
                this.changement_etage(etage_id);
            });

        } else {
            this.changement_etage(etage_id);
        }
    }

    changement_etage(etage_id) {
        this.etage_id = etage_id;
        window.history.pushState({}, '', '/croquis/' + this.dossier_intervention_id + '/' + this.fiche_intervention_id + '/' + this.etage_id);
        this.load_projet();
    }

    getEtages() {
        this.etageService.getEtages(this.fiche_intervention_id).subscribe((etages) => {
            this.etages = etages;
        });
    }

    getNiveaux() {
        this.niveauService.getNiveaux().subscribe((niveaux) => {
            this.niveaux = niveaux;
        });
    }

    getNomNiveau(niveau_id: number) {
        const niveauAfficher = this.niveaux.find(niveau => niveau.id === niveau_id);
        return niveauAfficher?.niveau;
    }

    retour_fiche_intervention(event: Event) {
        event.preventDefault();

        if (this.jsonOnLoad != get_json()) {
            const confirmation = this.fuseConfirmationService.open({
                title: 'Sauvegarde',
                message: 'Voulez-vous sauvegarder ce plan avant d\'être redirigé?',
                actions: {
                    confirm: {
                        label: 'Sauvegarde'
                    },
                    cancel: {
                        label: 'Non'
                    }
                }
            });

            confirmation.afterClosed().subscribe((result) => {
                if (result === 'confirmed') {
                    this.save_projet();
                }
                this.router.navigate([
                    '/dossiers-interventions',
                    this.dossier_intervention_id
                ]);
            });

        } else {
            this.router.navigate([
                '/dossiers-interventions',
                this.dossier_intervention_id,
            ]);
        }


    }
}
